import { IEltTopOpportunity } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltTopOpportunity'
import { TComplexSectionData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { useTableActions } from 'legacy/lut/components/widgets/public/partner360/ELT/hooks/useTableActions'
import { StyledTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import { Title } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/title/Title'
import { useMemo } from 'react'

import { getTopOpportunitiesColumns } from './helpers/getTopOpportunitiesColumns'

import styles from './TopOpportunities.module.scss'

interface IProps {
  data: IEltTopOpportunity[]
  updateFormData: (data: TComplexSectionData) => void
}

export const TopOpportunities = ({ data, updateFormData }: IProps) => {
  const { addRow, deleteRow, deleteLastRow, onChange, canAddNewRow } =
    useTableActions<IEltTopOpportunity>({
      updateFormData: updateFormData,
      data: data,
      newEmptyRow: { Deal: '', Size: 0 },
      canAddNewRowCondFn: (el) => !el.Deal && !el.Size,
    })

  const columns = useMemo(() => getTopOpportunitiesColumns({ onChange }), [onChange])

  return (
    <div className={styles.root}>
      <Title
        variant="withBackground"
        text={getFormedEltTranslation('doc-section-top-opportunities')}
      />

      <StyledTable<IEltTopOpportunity>
        canAddNewRow={canAddNewRow}
        columns={columns}
        items={data}
        addRow={addRow}
        deleteLastRow={deleteLastRow}
        deleteRow={deleteRow}
        maxLen={5}
      />
    </div>
  )
}
